<template>
    <b-modal
        id="add-student-modal"
        ref="add-student-modal"
        size="md"
        :title="$t('internship.add_student')"
        modal-class="apprentice-default-modal create-internship-tag"
        ok-only
        :ok-title="$t('common.close')"
        @show="load()">
        <p>{{ $t('internship.available_places') }} {{ availableSlots }}</p>
        <design-2021-apprentice-data-table
            :items="allAddableStudents"
            :fields="studentFields"
            show-empty>
            <template v-slot:cell(action)="data">
                <b-button
                    class="btn-sign-in btn-module-sign-in remove-icon-margin"
                    v-b-tooltip.hover
                    variant="primary-icon-only"
                    :title="$t('internship.register')"
                    @click="signUp(data.item.id)">
                </b-button>
            </template>

            <template #empty="scope">
                <div class="not-found with-header empty-student-list">
                    <div class="icon">
                        <i
                            class="fas fa-exclamation-circle"
                            data-v-e13f5460=""></i>
                    </div>
                    <div class="alert-notice">{{ $t('internship.no_available_students_to_add') }}</div>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </b-modal>
</template>

<script>
// import {ords} from "../../../app";
// import moment from "moment";

export default {
    name: 'design-2021-internship-edit-student-tab-add-modal-component',
    props: ['internshipIn', 'studentIdArrayIn', 'studentsIn'],
    data() {
        return {
            loaded: false,
            allStudents: [],
            eligableStudents: [],
            studentFields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'email',
                    label: this.$t('common.email_address'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    methods: {
        load() {
            if (!this.loaded) {
                this.tableData();
                this.loaded = true;
            }
        },
        tableData() {
            this.axios.get(this.routes.internshipStudentsForInternshipGet(this.internshipIn.id)).then(
                (response) => {
                    this.eligableStudents = response.data;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        signUp(studentId) {
            this.axios
                .post(this.routes.internshipAddStudent(studentId), {
                    internshipId: this.internshipIn.id,
                })
                .then(
                    (response) => {
                        this.alert.success();
                        let student = this.eligableStudents.find((student) => student.id === studentId);
                        student.pivot = {};
                        student.pivot.accepted = 1;
                        this.$emit('addStudent', student);
                        if (!this.availableSlots) {
                            this.$refs['add-student-modal'].hide();
                            this.loaded = false;
                        }
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
        },
        resetLoadedTofalse() {
            this.loaded = false;
        },
    },
    computed: {
        allAddableStudents() {
            if (this.loaded === false) {
                return [];
            } else {
                const filteredStudents = this.eligableStudents.filter(
                    (student) => !this.studentIdArrayIn.includes(student.id),
                );
                return filteredStudents.map((student) => {
                    return {
                        id: student.id,
                        name: student.full_name,
                        email: student.email,
                    };
                });
            }
        },
        availableSlots() {
            return this.internshipIn.slots - this.studentsIn.length;
        },
    },
    mounted() {},
};
</script>

<style scoped lang="scss">
.sidebar {
    margin-bottom: $grid-gutter-width;
}

.internships {
    .internship-item {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

        .internship-card {
            &.closed {
                filter: grayscale(1);
            }
        }
    }
}

.internship-show-actions {
    display: flex;
    flex-direction: row;
    align-items: center;

    > .btn {
        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }

        &:before {
            margin-right: 0;
        }
    }
}

.not-found {
    margin-top: #{3 * map-get($grid-gutter-spacing, 'twenty-one')};
}
</style>
